module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_4-f69ba82d70a34752118a3e6eb55a5a05.jpeg";